export default __webpack_public_path__ + "static/sub-mob-125f62e23753dc188f062aef708339d5.png";